import { memo, useState, useEffect, useImperativeHandle } from "react";
import { useSelector, useDispatch } from "react-redux";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Switch from "@mui/material/Switch";
import { setContextFilterOptions } from "redux/actions/flowDesigner/editorContextActionCreator";
import { CONTEXT_FILTERS } from "constants/flowDesigner";

const options = [
  { name: CONTEXT_FILTERS.COMPONENT_STEPS, enabled: true, label: "Component Steps" },
  { name: CONTEXT_FILTERS.CONNECTOR_STEPS, enabled: true, label: "Connector Steps" },
  { name: CONTEXT_FILTERS.SUCCESSFUL_STEPS, enabled: true, label: "Successful Steps" },
  { name: CONTEXT_FILTERS.FAILED_STEPS, enabled: true, label: "Failed Steps" },
  { name: CONTEXT_FILTERS.IN_PROGRESS_STEPS, enabled: true, label: "In-Progress Steps" }
  // {
  //   name: CONTEXT_FILTERS.STEPS_WITH_DATA_CHANGES,
  //   enabled: false,
  //   label: "Steps with Data Changes",
  // },
  // {
  //   name: CONTEXT_FILTERS.STEPS_WITHOUT_DATA_CHANGES,
  //   enabled: false,
  //   label: "Steps without Data Changes",
  // },
  // {
  //   name: CONTEXT_FILTERS.STEPS_WITH_USER_DEFINED_FIELDS,
  //   enabled: false,
  //   label: "Steps with User-Defined Fields",
  // },
  // {
  //   name: CONTEXT_FILTERS.STEPS_WITHOUT_USER_DEFINED_FIELDS,
  //   enabled: false,
  //   label: "Steps without User-Defined Fields",
  // },
  // { name: CONTEXT_FILTERS.RUNTIME_ERRORS, enabled: false, label: "Runtime Errors" },
  // { name: CONTEXT_FILTERS.AUTHORIZATION_ERRORS, enabled: false, label: "Authorization Errors" },
  // { name: CONTEXT_FILTERS.NETWORK_ERRORS, enabled: false, label: "Network Errors" },
  // { name: CONTEXT_FILTERS.USER_TRIGGERED_STEPS, enabled: false, label: "User-Triggered Steps" },
  // {
  //   name: CONTEXT_FILTERS.SYSTEM_TRIGGERRED_STEPS,
  //   enabled: false,
  //   label: "System-Triggerred Steps",
  // },
];

const FilterOptions = ({ ref }) => {
  const { contextFilterOptions } = useSelector((state) => state.designer.editorContext);
  const [filterOptions, setFilterOptions] = useState({});
  const dispatch = useDispatch();

  useImperativeHandle(ref, () => ({
    resetFilters,
    applyFilters
  }));

  const applyFilters = () => {
    dispatch(setContextFilterOptions(filterOptions));
  };

  const resetFilters = () => {
    setFilterOptions(contextFilterOptions);
  };

  const handleChangeFilterOption = (optionName) => {
    const filterOptionsCopy = { ...filterOptions };
    filterOptionsCopy[optionName] = !filterOptionsCopy[optionName];
    setFilterOptions(filterOptionsCopy);
  };

  useEffect(() => {
    const contextFilterOptionsCopy = { ...contextFilterOptions };
    setFilterOptions(contextFilterOptionsCopy);
  }, [contextFilterOptions]);

  return (
    <List>
      {options.map((option) => (
        <ListItem
          key={option.name}
          secondaryAction={
            <Switch
              edge="end"
              disabled={!option.enabled}
              onChange={() => handleChangeFilterOption(option.name)}
              checked={filterOptions[option.name] || false}
              slotProps={{
                input: {
                  "aria-labelledby": option.name
                }
              }}
            />
          }
        >
          <ListItemText secondary={option.label} />
        </ListItem>
      ))}
    </List>
  );
};

export default memo(FilterOptions);
